<template>
  <div class="component-title">
    <div>
      <div
        :style="
          'height:' +
          (config.property_data.h2 ? '60' : '52') +
          'px; position:relative;display: flex;justify-content: center;background-color:' +
          config.property_data.background_color +
          ''
        "
      >
        <div class="title-sup-center">
          <div style="display: flex; align-items: center">
            <div
              v-if="config.property_data.h1"
              class="title-sub-h1"
              :style="
                'margin-left: 0px; line-height:22px;color:' +
                config.property_data.h1_color
              "
            >
              <div
                class="left_img"
                :style="`left:-${config.property_data.padding}px`"
              >
                <img :src="config.property_data.choose_photo_left" alt="" />
              </div>
              <div class="text">{{ config.property_data.h1 }}</div>
              <div
                class="right_img"
                :style="`right:-${config.property_data.padding}px`"
              >
                <img :src="config.property_data.choose_photo_right" alt="" />
              </div>
            </div>
          </div>
          <div
            v-if="config.property_data.h2"
            class="title-sub-h2"
            :style="
              'margin-left: 0px;margin-top: 1px;line-height:17px;color:' +
              config.property_data.h2_color
            "
          >
            {{ config.property_data.h2 }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "tms-title",
  props: ["config"],

  // 标题组件 上传图片
  data() {
    return {
      link_data: null,
    };
  },

  computed: {
    h1Color() {
      return "color:#" + this.config.property_data.h1_color;
    },
    styleType() {
      return "title-" + this.config.style_type;
    },
  },

  components: {},

  mounted() {},

  methods: {},
};
</script>

<style  lang="scss" scoped>
@import "./index.scss";
</style>